import { isMerchantAccountDelinquent } from '../component-helpers/common';
import { useBillingInfo } from '../contexts/providers/billingInfo';

export const useMerchantDelinquencyStatus = (): boolean => {
  const merchantBillingInformation = useBillingInfo();
  return isMerchantAccountDelinquent(merchantBillingInformation);
};
